import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import FeaturesSection from './components/FeaturesSection';
import LotteryTypesSection from './components/LotteryTypesSection';
import HowItWorksSection from './components/HowItWorksSection';
import TestimonialsSection from './components/TestimonialsSection';
import ArticlesSection from './components/ArticlesSection';
import FaqSection from './components/FaqSection';
import DownloadCtaSection from './components/DownloadCtaSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <FeaturesSection />
        <LotteryTypesSection />
        <HowItWorksSection />
        <ArticlesSection />
        <TestimonialsSection />
        <FaqSection />
        <DownloadCtaSection />
      </main>
      <Footer />
    </>
  );
}